var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCanvas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M783 591c16-12 40-9 53 7 13 17 10 41-7 54L543 870c-22 17-53 17-76 0L182 652c-17-13-20-37-7-54 13-16 37-19 53-6l238 189c23 18 55 18 78 0l238-189c1 0 1-1 1-1zM467 139c22-19 55-19 77 0l275 218c4 3 7 6 10 10 21 27 17 66-10 88l-7 5-268 213c-22 18-55 18-77 0L198 460l-6-5c-4-3-7-7-10-10-22-27-17-67 10-88z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCanvas);
export default __webpack_public_path__ + "static/media/ic_canvas.499ffb874401ed4a1e9d202d4afb53ed.svg";
export { ForwardRef as ReactComponent };